import { createRequest } from "helpers/tools";

export const getLeadGoogleFields = async () => {
    return await createRequest({
        suffix: `lead/gglw/fields`,
        handleError: true,
        method: "get",
    });
};
export const getLeadGoogleSourceDetail = async (id) => {
    return await createRequest({
        suffix: `lead/gglw/${id}`,
        handleError: true,
        method: "get",
    });
};

export const postLeadGoogleSource = async (payload) => {
    return await createRequest({
        suffix: `lead/gglw`,
        handleError: true,
        method: "post",
        payload,
    });
};
export const updateLeadGoogleSource = async (id, payload) => {
    return await createRequest({
        suffix: `lead/gglw/${id}/update`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const getCreatedLeadGoogleSources = async () => {
    return await createRequest({
        suffix: `lead/gglw`,
        handleError: true,
        method: "get",
    });
};

export const getLeadGoogleWebhookURL = async (id) => {
    return await createRequest({
        suffix: `lead/gglw/${id}/document`,
        handleError: true,
        method: "get",
    });
};
